import styled from 'styled-components';

const Text = styled.span`
  padding-right: 0.5rem;
`;

export default Text;
